import { render } from "./CreateUp.vue?vue&type=template&id=64bf55f2&scoped=true"
import script from "./CreateUp.vue?vue&type=script&lang=js"
export * from "./CreateUp.vue?vue&type=script&lang=js"

import "./CreateUp.vue?vue&type=style&index=0&id=64bf55f2&scoped=true&lang=css"

import exportComponent from "D:\\code\\miao_up_up_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64bf55f2"]])

export default __exports__